var render = function render(){
  var _vm$stock_saving_erro, _vm$stock_saving_erro2, _vm$stock_saving_erro3, _vm$stock_saving_erro4, _vm$stock_saving_erro5, _vm$stock_saving_erro6, _vm$stock_saving_erro7, _vm$stock_saving_erro8;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-stock-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_vm.showWarehousesGate ? _c('PremiumFeatureGateWarehouses') : [_c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-warehouse")]), _c('span', [_vm._v("Information")])], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "error-messages": (_vm$stock_saving_erro = _vm.stock_saving_errors) === null || _vm$stock_saving_erro === void 0 ? void 0 : _vm$stock_saving_erro.name,
      "label": _vm.$translate('labels.name') + ' *',
      "disabled": !_vm.isStockOwner,
      "name": "name",
      "autofocus": "",
      "dense": true,
      "required": ""
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.stock.name,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "name", $$v);
      },
      expression: "stock.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "error-messages": (_vm$stock_saving_erro2 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro2 === void 0 ? void 0 : _vm$stock_saving_erro2.code,
      "label": _vm.$translate('labels.code_automatically_generated'),
      "name": "code",
      "disabled": !_vm.isStockOwner,
      "dense": true
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.stock.code,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "code", $$v);
      },
      expression: "stock.code"
    }
  })], 1), _vm.showEstablishmentField ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('SearchEstablishment', {
    attrs: {
      "outlined": "",
      "value": _vm.stock.establishment,
      "label": _vm.$translate('labels.establishment'),
      "error-messages": (_vm$stock_saving_erro3 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro3 === void 0 ? void 0 : _vm$stock_saving_erro3.establishment,
      "disabled": !_vm.isStockOwner,
      "allow-create": _vm.isStockOwner && _vm.userHasPermission('core.add_establishment'),
      "hide-details": "auto",
      "dense": true
    },
    on: {
      "input": _vm.onEstablishmentInput
    },
    nativeOn: {
      "keydown": function keydown($event) {
        return _vm.handleKeyPress.apply(null, arguments);
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-package-variant")]), _c('span', [_vm._v(_vm._s(_vm.$translate("stock_tracking")))])], 1), _c('v-row', {
    staticClass: "mt-0 mb-6"
  }, [_c('v-col', {
    staticClass: "mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.isStockOwner,
      "label": _vm.$translate('enable_stock_tracking'),
      "hide-details": ""
    },
    model: {
      value: _vm.stock.track_stock,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "track_stock", $$v);
      },
      expression: "stock.track_stock"
    }
  }), _c('p', {
    staticClass: "text-caption text--secondary mb-0 mt-2"
  }, [_vm._v(" " + _vm._s(_vm.$translate("stock_tracking_explanation")) + " ")])], 1)], 1)], 1)], 1), _vm.stock.track_stock ? _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-map-marker-multiple-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate('storageLocationsTitle')))])], 1), _c('StorageLocationsEditor', {
    staticClass: "mt-4 mb-6",
    attrs: {
      "value": _vm.stock.storage_locations,
      "create-first": _vm.createFirstStorageLocation,
      "new-warehouse": _vm.isNew,
      "disabled": !_vm.isStockOwner || _vm.stock_saving,
      "errors": ((_vm$stock_saving_erro4 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro4 === void 0 ? void 0 : _vm$stock_saving_erro4.storage_locations) || ((_vm$stock_saving_erro5 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro5 === void 0 ? void 0 : _vm$stock_saving_erro5.storage_locations_enabled)
    },
    on: {
      "input": _vm.onStorageLocationsInput
    }
  })], 1)], 1) : _vm._e(), _vm.showLogisticsOperatorField ? _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-truck-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("logistics_operator_section")))])], 1), _c('p', {
    staticClass: "text-caption text--secondary mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$translate("logistics_operator_help")) + " ")]), _c('SearchOperator', {
    staticClass: "mb-4",
    attrs: {
      "outlined": "",
      "allow-create": true,
      "additional-params": _vm.warehouseOperatorSearchParams,
      "create-modal-params": _vm.warehouseOperatorCreateModalParams,
      "disabled": !_vm.isStockOwner,
      "readonly": !_vm.isStockOwner,
      "error-messages": (_vm$stock_saving_erro6 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro6 === void 0 ? void 0 : _vm$stock_saving_erro6.operator
    },
    model: {
      value: _vm.stock.operator,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "operator", $$v);
      },
      expression: "stock.operator"
    }
  })], 1)], 1) : _vm._e(), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("labels.address")))])], 1), _c('AddressForm', {
    staticClass: "mt-0",
    attrs: {
      "outlined": "",
      "title": null,
      "readonly": !_vm.isStockOwner,
      "errors": (_vm$stock_saving_erro7 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro7 === void 0 ? void 0 : _vm$stock_saving_erro7.address,
      "highlight-mandatory": false
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.stock.address,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "address", $$v);
      },
      expression: "stock.address"
    }
  }), _c('v-textarea', {
    staticClass: "mt-5",
    attrs: {
      "outlined": "",
      "label": _vm.$translate('labels.delivery_instructions'),
      "error-messages": (_vm$stock_saving_erro8 = _vm.stock_saving_errors) === null || _vm$stock_saving_erro8 === void 0 ? void 0 : _vm$stock_saving_erro8.delivery_instructions,
      "disabled": !_vm.isStockOwner
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.stock.delivery_instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.stock, "delivery_instructions", $$v);
      },
      expression: "stock.delivery_instructions"
    }
  })], 1)], 1)], 1)]], 2), _c('template', {
    slot: "bottom"
  }, [_vm.showWarehousesGate ? _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('buttons.close'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }) : [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.isStockOwner ? _vm.$translate('buttons.cancel') : _vm.$translate('buttons.close'),
      "disabled": _vm.stock_saving,
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }), _vm.isStockOwner ? _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.save_text,
      "loading": _vm.stock_saving,
      "disabled": _vm.stock_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  }) : _vm._e()]], 2)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }